import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';
import { useActiveUserStore } from '@/stores/user';
import { routeKillSession, handleRoute } from '@/modules/routing.js';
import {
  destroyUserSession,
  createUserSession,
} from '@/helpers/session-helpers.js';
import { setDocumentTitle } from '@/helpers/helpers';
import i18next from '@/helpers/i18n';

export function createCutrRouter(routes: RouteRecordRaw[]) {
  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.afterEach((to) => {
    window.productFruits?.pageChanged?.();
    if (to.meta.title) {
      setDocumentTitle(
        i18next.t(`order:tabTitle.${to.meta.title}`, to.meta.title)
      );
    }
  });

  router.beforeEach(async (to) => {
    const userStore = useActiveUserStore();
    const resolveRoute = () =>
      handleRoute(userStore.activeSessionType, userStore.activeSessionRole, to);

    // Some routes will end current session to ensure people get there: forgotpass, resetpass, signup.
    if (routeKillSession[to.name as keyof typeof routeKillSession]) {
      await destroyUserSession();
      return resolveRoute();
    }

    if (userStore.userLoaded && userStore.activeSessionType !== 'Public')
      return resolveRoute();

    await createUserSession();
    return resolveRoute();
  });

  return router;
}
